import React, { useState } from "react";
import 'react-multi-carousel/lib/styles.css';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';

import NoraHomepage from '../../images/homepage/nora-homepage.png';

import 'swiper/swiper-bundle.css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

import Review5 from "../../images/homepage/review5.png";
import Review6 from "../../images/homepage/review6.png";
import Review7 from "../../images/homepage/review7.png";
import Review8 from "../../images/homepage/review8.png";
import Review9 from "../../images/homepage/review9.png";
import Container from "../../images/homepage/container.png";
import ContainerMobile from "../../images/homepage/containerMobile.png";

import CompanyCards from '../../components/CompanyCards';
import SEO from '../../components/SEO';
import { generateBreadcrumbSchema, generateFAQSchema } from '../../utils/schemaGenerator';

function ComparisonLockedInAI() {
  let navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const breadcrumbSchema = generateBreadcrumbSchema([
    { name: 'Home', url: 'https://interview.norahq.com' },
    { name: 'LockedIn AI Alternative', url: 'https://interview.norahq.com/lockedin-ai-alternative' }
  ]);

  const lockedInFaqEntries = [
    {
      question: 'How is Nora different from LockedIn AI?',
      answer: 'Nora is for ethical, realistic interview practice before your interview—voice-based mock sessions with detailed feedback—while LockedIn AI focuses on live assistance during interviews.'
    },
    {
      question: 'How much does Nora cost?',
      answer: 'Your first mock interview is free. Then $15/month with an annual option.'
    },
    {
      question: 'Does Nora support non-technical roles?',
      answer: 'Yes. Nora supports behavioral, standard, technical, and salary negotiation practice for many roles.'
    }
  ];

  const faqSchema = generateFAQSchema(lockedInFaqEntries);

  return (
    <>
    <SEO
        title="LockedIn AI Alternative — Practice Real Interviews with Nora"
        description="Compare Nora and LockedIn AI: realistic mock interviews, honest feedback, and $15/month pricing. Your first mock interview is free."
        url="https://interview.norahq.com/lockedin-ai-alternative"
        openGraph={{
          description: 'Realistic practice, honest feedback, $15/month. First mock is free.'
        }}
        schemas={[breadcrumbSchema, faqSchema]}
    />

      <div className="comparison-container">
        {/* Hero Section */}
        <div className="screening-hero-section">
            <div className="screening-hero-content">
                <div className="screening-hero-left">
                    <h1 className="position-title-h1">
                        LockedIn AI Alternative - AI Mock Interviewer for Interview Prep
                    </h1>
                    <p className="position-title-p">
                        While LockedIn AI provides real-time interview assistance during live interviews,
                        Nora AI helps you <strong>genuinely prepare</strong> through realistic mock interviews.
                        <br /><br />
                        Build real confidence, avoid detection risks, and actually improve your skills at $15/month vs $119.99/month.
                    </p>

                    <div className="btn-container2">
                        <button
                            className="nora-button-style"
                            onClick={() => window.open('https://interview.norahq.com', '_blank')}
                            style={isMobile ? { fontSize: '16px' } : {}}
                        >
                            Try Nora AI Free
                        </button>

                        <button
                            onClick={() => window.location.href = '#comparison'}
                            className="nora-button2-style"
                        >
                            See Comparison
                        </button>
                    </div>

                    <div className="trust-indicators">
                        <div className="trust-item">
                            <span className="checkmark">✓</span>
                            <span>100% Ethical & Legal</span>
                        </div>
                        <div className="trust-item">
                            <span className="checkmark">✓</span>
                            <span>Zero Detection Risk</span>
                        </div>
                        <div className="trust-item">
                            <span className="checkmark">✓</span>
                            <span>87% More Affordable</span>
                        </div>
                    </div>
                </div>

                <div className="screening-hero-right">
                    <div>
                        <img
                            src={NoraHomepage}
                            alt="Nora AI - Ethical Interview Preparation"
                            style={{ maxWidth: '100%', display: 'block' }} />
                    </div>
                </div>
            </div>
        </div>

        {/* Pricing Comparison Section */}
        <div className="pricing-comparison-section" id="pricing-lockedInAI">
            <h2 className="pricing-title2">Cheating costs $119.99. Getting better costs $15</h2>

            <div className="pricing-cards-container">
                {/* Nora AI Card */}
                <div className="pricing-card2 pricing-card-featured">
                    <div className="pricing-card-header">
                        <div>
                            <h3 className="pricing-card-title">Nora AI</h3>
                            <p className="pricing-card-subtitle">AI Mock Interview prep</p>
                        </div>
                        <div className="pricing-badge">
                            <span>⚡</span>
                        </div>
                    </div>

                    <div className="pricing-amount-container">
                        <span className="pricing-currency">$</span>
                        <span className="pricing-amount2">15</span>
                        <span className="pricing-period2">/month</span>
                    </div>

                    <button
                        className="pricing-cta-button pricing-cta-primary"
                        onClick={() => window.open('https://interview.norahq.com', '_blank')}
                    >
                        Start for free <span className="arrow-icon">→</span>
                    </button>

                    <div className="pricing-features-list">
                        <div className="pricing-feature-item">
                            <span className="feature-check">✓</span>
                            <span>Unlimited mock interviews</span>
                        </div>
                        <div className="pricing-feature-item">
                            <span className="feature-check">✓</span>
                            <span>Detailed feedback & analysis</span>
                        </div>
                        <div className="pricing-feature-item">
                            <span className="feature-check">✓</span>
                            <span>Technical & behavioral modes</span>
                        </div>
                        <div className="pricing-feature-item">
                            <span className="feature-check">✓</span>
                            <span>Salary negotiation practice</span>
                        </div>
                        <div className="pricing-feature-item">
                            <span className="feature-check">✓</span>
                            <span>Resume & job description matching</span>
                        </div>
                        <div className="pricing-feature-item">
                            <span className="feature-check">✓</span>
                            <span>Action plans & improvement tips</span>
                        </div>
                        <div className="pricing-feature-item">
                            <span className="feature-check">✓</span>
                            <span>100% ethical & legal</span>
                        </div>
                    </div>
                </div>

                {/* LockedIn AI Card */}
                <div className="pricing-card2 pricing-card-competitor">
                    <div className="pricing-card-header">
                        <div>
                            <h3 className="pricing-card-title">LockedIn AI</h3>
                            <p className="pricing-card-subtitle">Real-time interview copilot</p>
                        </div>
                        <div className="pricing-badge pricing-badge-warning">
                            <span>💰</span>
                        </div>
                    </div>

                    <div className="pricing-amount-container">
                        <span className="pricing-currency">$</span>
                        <span className="pricing-amount2">119.99</span>
                        <span className="pricing-period2">/month</span>
                    </div>

                    <button className="pricing-cta-button pricing-cta-disabled">
                        🚫 Risky shortcuts <span className="arrow-icon">→</span>
                    </button>

                    <div className="pricing-features-list">
                        <div className="pricing-feature-item">
                            <span className="feature-check">✓</span>
                            <span>Unlimited sessions</span>
                        </div>
                        <div className="pricing-feature-item">
                            <span className="feature-check">✓</span>
                            <span>Advanced AI models</span>
                        </div>
                        <div className="pricing-feature-item">
                            <span className="feature-check">✓</span>
                            <span>Stealth mode (premium only)</span>
                        </div>
                        <div className="pricing-feature-item">
                            <span className="feature-check">✓</span>
                            <span>Real-time assistance</span>
                        </div>
                        <div className="pricing-feature-item pricing-feature-negative">
                            <span className="feature-cross">✕</span>
                            <span>8x more expensive ($119.99 vs $15)</span>
                        </div>
                        <div className="pricing-feature-item pricing-feature-negative">
                            <span className="feature-cross">✕</span>
                            <span>No refund policy</span>
                        </div>
                        <div className="pricing-feature-item pricing-feature-negative">
                            <span className="feature-cross">✕</span>
                            <span>Violates interview policies</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* Benefits/Differences Section */}
        <div className="benefits-section" id="comparison">
            <div className="benefits-content">
                <div className="benefits-left">
                    <h2 className="benefits-title">How is Nora different from LockedIn AI?</h2>
                    <p className="benefits-description">
                        Nora is built for real growth, not shortcuts
                    </p>

                    <div className="benefits-tags">
                        <span className="benefit-tag">Ethical & Legal</span>
                        <span className="benefit-tag">Builds Real Skills</span>
                        <span className="benefit-tag">Zero Detection Risk</span>
                        <span className="benefit-tag">87% More Affordable</span>
                    </div>
                </div>

                <div className="benefits-right">
                    <div className="benefit-point">
                        <div className="benefit-icon">💰</div>
                        <div className="benefit-content">
                            <h3 className="benefit-heading">87% more affordable</h3>
                            <p className="benefit-text">
                                LockedIn AI costs $119.99/month for unlimited premium access. Nora AI is just $15/month,
                                giving you better value with unlimited practice interviews and no hidden fees.
                            </p>
                            <a href="#pricing-lockedInAI" className="benefit-link" onClick={() => window.location.href = '#pricing-lockedInAI'}>See pricing comparison →</a>
                        </div>
                    </div>

                    <div className="benefit-point">
                        <div className="benefit-icon">🛡️</div>
                        <div className="benefit-content">
                            <h3 className="benefit-heading">Zero detection risk</h3>
                            <p className="benefit-text">
                                LockedIn AI tools often raise red flags in live sessions.
                                Nora AI is used for preparation only, making it 100% safe and compliant.
                            </p>
                            <a href="https://interview.norahq.com" className="benefit-link">Try Nora free →</a>
                        </div>
                    </div>

                    <div className="benefit-point">
                        <div className="benefit-icon">📈</div>
                        <div className="benefit-content">
                            <h3 className="benefit-heading">Grow genuine confidence</h3>
                            <p className="benefit-text">
                                Instead of relying on live prompts,
                                Nora helps you internalize strategies through feedback and personalized improvement plans.
                            </p>
                            <a href="#comparison" className="benefit-link" onClick={() => window.location.href = '#comparison'}>See full comparison →</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="outsourcing-solution" id="how-it-works">
            <h2 className="outsourcing-heading">How Nora Works</h2>
            <p className="outsourcing-description">
                3 simple steps to level up your interview game
            </p>
        </div>

        <div className="how-it-works-1-partnership">
            <img src={isMobile ? ContainerMobile : Container} loading="lazy" alt="Feedback" id="feedback-picture" className='image2-styling' />
        </div>

        <div className="outsourcing-solution">
            <h2 className="outsourcing-heading">Watch Nora in Real Time</h2>
            <p className="outsourcing-description" style={{ marginBottom: '50px' }}>
                Watch how Nora works in real life, and can offer valuable interview practice.
            </p>
            <iframe
                width={isMobile ? "380" : "640"}
                height={isMobile ? "214" : "360"}
                src="https://www.youtube.com/embed/7u0Rf3D_jN0?si=wlmJwsxo5_QjGrrl"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen>
            </iframe>
        </div>

        <div className="cool-homepage-section">
            <h2 className="outsourcing-heading">"This feels like having the interview questions a day before."</h2>
            <div className="button-container">
                <button className="nora-button-style"
                    style={{ marginTop: '10px' }}
                    onClick={() => navigate("/login")}>
                    And the interview answers.
                </button>
            </div>
        </div>

        <div className="cta-container" id="testimonials">
            <div className="cta-text">Hear from Applicants like you</div>
        </div>
        <div>
            <Swiper
                spaceBetween={0}
                slidesPerView={isMobile ? 1 : 3}
                modules={[Pagination]}
                pagination={{ clickable: true }}
                style={{ margin: 'auto', paddingBottom: '70px', paddingTop: '20px' }}
            >
                <SwiperSlide>
                    <div className="card">
                        <div className="card-top">
                            <img
                                src={Review5}
                                alt="Samantha Chou Photo"
                                className="card-image-styling" />
                        </div>
                        <div className="card-content">
                            <h3>Samantha Chou</h3>
                            <p className="title">PM Intern at Amazon</p>
                            <p className="quote">
                                “Nora is a helpful and easy-to-use mock interview tool.
                                Love the interactive nature and the question-by-question feedback and analysis!
                                Very useful in the job searching process!”
                            </p>
                        </div>
                    </div>
                </SwiperSlide>

                <SwiperSlide>
                    <div className="card">
                        <div className="card-top">
                            <img
                                src={Review7}
                                alt="Dev Popat Photo"
                                className="card-image-styling" />
                        </div>
                        <div className="card-content">
                            <h3>Dev Popat</h3>
                            <p className="title">SWE at Roku</p>
                            <p className="quote">
                                “I completed 3 mock interviews before my actual interview at Roku,
                                and 4 out of the 7 questions were exactly the same!
                                This is a must-use tool for anyone preparing for interviews!”
                            </p>
                        </div>
                    </div>
                </SwiperSlide>

                <SwiperSlide>
                    <div className="card">
                        <div className="card-top">
                            <img
                                src={Review8}
                                alt="Julia Son Photo"
                                className="card-image-styling" />
                        </div>
                        <div className="card-content">
                            <h3>Julia Son</h3>
                            <p className="title">Marketing at Meta</p>
                            <p className="quote">
                                “Easily the best way to prepare for an interview.
                                With constructive, personalized feedback, I'd recommend Nora to anybody looking to
                                prepare for any upcoming interviews. Such a great resource!”
                            </p>
                        </div>
                    </div>
                </SwiperSlide>

                <SwiperSlide>
                    <div className="card">
                        <div className="card-top">
                            <img
                                src={Review6}
                                alt="Carissa Wu Photo"
                                className="card-image-styling" />
                        </div>
                        <div className="card-content">
                            <h3>Carissa Wu</h3>
                            <p className="title">Computer Engineering, Senior</p>
                            <p className="quote">
                                “Great tool that simulates real life interviews.
                                I used it to practice for a web developer position,
                                and the questions Nora asked were what my interviewer asked me.”
                            </p>
                        </div>
                    </div>
                </SwiperSlide>

                <SwiperSlide>
                    <div className="card">
                        <div className="card-top">
                            <img
                                src={Review9}
                                alt="Sydney Nguyen Photo"
                                className="card-image-styling" />
                        </div>
                        <div className="card-content">
                            <h3>Sydney Nguyen</h3>
                            <p className="title">Sales, Senior at UCR</p>
                            <p className="quote">
                                “Nora is super helpful and gives realistic questions.
                                I love the specific focus on information provided from your resume - it's especially helpful for creative positions
                                that require a wide variety of skills. 100% recommend!”
                            </p>
                        </div>
                    </div>
                </SwiperSlide>
            </Swiper>

        </div>

        {/* Company Mock Interview Section */}
        <div>
            <h2 className="company-mock-section-section">Jump start your interview practice now.</h2>
            <CompanyCards />
        </div>

        <div className={isMobile ? "practiceNoraCard-mobile" : "practiceNoraCard"}>
            <div style={{ textAlign: "center" }}>
                <div className={isMobile ? "practiceNoraCardHead-mobile" : "practiceNoraCardHead"}>Ready to begin mastering interviews with Nora?</div>

                <button className="nora-button-style"
                    onClick={() => navigate("/login")}>
                    Practice Now
                </button>
            </div>
        </div>

        <Footer />
    </div>
</>
  );
}

export default ComparisonLockedInAI;
